import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';

import { Button, Dialog, FormControl, NotificationManager, Space, TextInput } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { NOTIFICATION_TIMEOUT } from '../../../../constants/common';
import { HttpClientEmail } from '../../../../helpers/email/httpClientEmail';
import { useViewPlatform } from '../../../../hooks/useViewPlatform';
import { errorTextContainEmailTemplateData } from '../../../../server/services/email/template/errorTextContainEmailTemplate';

import styles from './pop-up-text-error.module.scss';

const errorLongText = () =>
  NotificationManager.show({
    title: 'Слишком много текста',
    subtitle: '',
    message: 'Выберите участок не более 3-4 строк и попробуйте снова отправить ошибку',
    type: 'error',
    timeout: NOTIFICATION_TIMEOUT,
  });
const successTextSend = () =>
  NotificationManager.show({
    title: 'Спасибо за внимательность!',
    subtitle: '',
    message: 'Мы проверим текст и исправим в ближайшее время',
    type: 'success',
    timeout: NOTIFICATION_TIMEOUT,
  });

export const PopUpTextError = memo(() => {
  const [text, setText] = useState('');
  const [comment, setComment] = useState<string>('');
  const [commentErrorMaxLength, setCommentErrorMaxLength] = useBoolean(false);
  const [visible, setVisible] = useBoolean(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorSend, setErrorSend] = useState<errorTextContainEmailTemplateData>();

  const platformOs = useViewPlatform();

  const viewModal = () => {
    const selectedText = window.getSelection().toString();
    if (selectedText.length >= 250) {
      errorLongText();
      return false;
    }
    setText(selectedText);
    setVisible.on();
  };

  useEffect(() => {
    document.onkeydown = (key: KeyboardEvent) => {
      switch (platformOs) {
        case 'Windows':
          key.ctrlKey && key.key === 'Enter' && viewModal();
          break;
        case 'Mac':
          key.metaKey && key.key === 'Enter' && viewModal();
          break;
        default:
          key.ctrlKey && key.key === 'Enter' && viewModal();
          break;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [platformOs]);

  useEffect(() => {
    setErrorSend({
      commentAuthorErrorText: comment,
      textError: text,
      headerArticle: document.title,
      linkArticle: document.URL,
    });
  }, [comment, text]);

  const handleSubmit = async () => {
    if (comment.length > 1000) {
      setCommentErrorMaxLength.on();
      return;
    } else {
      setCommentErrorMaxLength.off();
    }

    setIsLoading(true);
    try {
      await HttpClientEmail.sendErrorTextForm(errorSend);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      setComment('');
      setVisible.off();
      successTextSend();
    }
  };

  return (
    <>
      <Dialog className={styles.dialog} visible={visible} onClose={setVisible.off}>
        <Dialog.Header title={'Отправить ошибку'} />
        <Dialog.Content className={styles.content}>
          <Space direction={'vertical'} size={16}>
            {text}
            <TextInput
              // maxLength={1000}
              value={comment}
              onChange={(e: React.FormEvent<HTMLInputElement>) => setComment(e.currentTarget.value)}
              placeholder={'Можете добавить комментарий'}
            />
            <FormControl.HelperText className={classNames('h-color-R100')}>
              {commentErrorMaxLength && 'Максимальная длинна комментария 1000 символов'}
            </FormControl.HelperText>
          </Space>
        </Dialog.Content>
        <Dialog.Footer className={styles.footer}>
          <Button onClick={handleSubmit} className={styles.button} variant={'primary'} size={52} loading={isLoading}>
            Отправить
          </Button>
        </Dialog.Footer>
      </Dialog>
    </>
  );
});
